import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { MultiTariffUpsaleDialogProps } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/multiTariffUpsaleDialog';

export const tryRenderMultiTariffUpsaleDialog = (data: MultiTariffUpsaleDialogProps) => {
    if (data.upsaleModel.getUpsaleProduct()) {
        openPopupHelper({
            popupName: popupNames.UPSALE_MULTI_TARIFF,
            data,
            onClose: data.onClose,
        });

        return true;
    }
    return false;
};
